import React from "react";
import PropTypes from "prop-types";
import { Avatar, Bubble } from "..";
import style from "./style.module.css";

const AvatarStack = ({
  profiles = [],
  stackSize,
  avatarSize = "36px",
  marginIndentation,
  profilesTotalCount,
  className
}) => {
  const visibleProfiles = profiles
    .slice(0, stackSize - 1 || profiles.length)
    .reverse();

  const hiddenProfilesCount =
    (profilesTotalCount || profiles.length) - visibleProfiles.length;

  const marginIndent =
    marginIndentation || `${parseInt(avatarSize, 10) / 4.5}px`;

  const dynamicStyle = {
    stack: {
      paddingLeft: marginIndent
    },
    avatar: {
      marginLeft: `-${marginIndent}`
    }
  };

  return (
    <div
      className={`${style.stack} ${className} notranslate`}
      style={dynamicStyle.stack}
    >
      {hiddenProfilesCount > 0 && (
        <div style={dynamicStyle.avatar}>
          <Bubble
            theme="gray"
            display={hiddenProfilesCount.toString()}
            size={avatarSize}
          />
        </div>
      )}
      {visibleProfiles.map((profile, index) => (
        <div style={dynamicStyle.avatar} key={profile.id}>
          <Avatar name={profile.name} size={avatarSize} src={profile.src} />
        </div>
      ))}
    </div>
  );
};
AvatarStack.propTypes = {
  profiles: PropTypes.array,
  AvatarSize: PropTypes.string,
  stackSize: PropTypes.number,
  noBorder: PropTypes.bool,
  src: PropTypes.string,
  marginIndentation: PropTypes.string,
  profilesTotalCount: PropTypes.number
};

export default AvatarStack;
